import MuiTableContainer, { TableContainerProps } from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow, { TableRowProps } from '@mui/material/TableRow';
import { Card, Box, TableCell } from '@mui/material';
import { Link, type LinkProps } from 'react-router-dom';

type TableContainerWithCardProps = TableContainerProps & {
  elevation?: number;
  square?: boolean;
};

const TableContainer = (props: TableContainerWithCardProps) => (
  <MuiTableContainer component={Card} {...props}>
    <Box>{props.children}</Box>
  </MuiTableContainer>
);

const TableRowWithHover = (props: TableRowProps) => {
  return <TableRow hover {...props} />;
};

const TableRowWithLink = (props: TableRowProps & LinkProps) => {
  const { to, target = '_blank', children, sx, ...rest } = props;

  return (
    <TableRowWithHover
      sx={{
        position: 'relative',
        '& td:nth-last-of-type(2)': {
          paddingRight: 3,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
      <TableCell
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
          border: 'none',
        }}
      >
        <Box
          component={Link}
          to={to}
          target={target}
          sx={{
            display: 'block',
            width: '100%',
            height: '100%',
            textDecoration: 'none',
          }}
        />
      </TableCell>
    </TableRowWithHover>
  );
};

export {
  Table,
  TableBody,
  TableHead,
  TableRowWithLink,
  TableRowWithHover as TableRow,
  TableContainer,
};
